import { useEffect } from 'react';
import { resizeSelectElementToCurrentValue } from '@/helpers/utils';

export const useResizeSelectElement = (selectId, condition) => {
  useEffect(() => {
    const select = document.querySelector(selectId);
    if (select) {
      resizeSelectElementToCurrentValue(select);
    }
  }, [selectId, condition]);
};
